import { 
  Dialog, 
  DialogContent, 
  DialogHeader, 
  DialogTitle,
  DialogFooter 
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Question } from './types';

interface ViewQuestionDialogProps {
  isOpen: boolean;
  onClose: () => void;
  question: Question | null;
}

export const ViewQuestionDialog = ({
  isOpen,
  onClose,
  question,
}: ViewQuestionDialogProps) => {
  if (!question) return null;

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle>Question Details</DialogTitle>
        </DialogHeader>
        
        <div className="space-y-6">
          <div>
            <h3 className="font-semibold mb-2">Question Text</h3>
            <p className="text-muted-foreground leading-relaxed">
              {question.question_text}
            </p>
          </div>

          <div className="flex gap-4">
            <div>
              <h3 className="font-semibold mb-2">Type</h3>
              <Badge variant="secondary">
                {question.question_type.replace('_', ' ')}
              </Badge>
            </div>
            <div>
              <h3 className="font-semibold mb-2">Correct Answer</h3>
              <code className="bg-muted px-2 py-1 rounded text-sm">
                {Array.isArray(question.correct_answer) ? question.correct_answer.join(', ') : question.correct_answer}
              </code>
            </div>
          </div>

          {question.options && Array.isArray(question.options) && question.options.length > 0 && (
            <div>
              <h3 className="font-semibold mb-2">Options</h3>
              <ul className="space-y-2">
                {question.options.map((option: string, index: number) => (
                  <li key={index} className="flex items-center gap-2">
                    <span className="font-mono text-sm bg-muted px-2 py-1 rounded">
                      {String.fromCharCode(65 + index)}
                    </span>
                    <span className={(Array.isArray(question.correct_answer) && question.correct_answer.includes(option)) ? 'font-semibold text-green-600' : ''}>
                      {option}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          )}

          {question.explanation && (
            <div>
              <h3 className="font-semibold mb-2">Explanation</h3>
              <p className="text-muted-foreground leading-relaxed bg-muted/50 p-3 rounded-lg">
                {question.explanation}
              </p>
            </div>
          )}

          <div className="grid grid-cols-2 gap-4 text-sm text-muted-foreground">
            <div>
              <span className="font-medium">Created:</span> {new Date(question.created_at).toLocaleDateString()}
            </div>
            <div>
              <span className="font-medium">Updated:</span> {new Date(question.updated_at).toLocaleDateString()}
            </div>
          </div>
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={onClose}>
            Close
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};